
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_1113_298350)","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M8.148 3.436v9.285M6.36 12.72h3.57M4.219 5.221V4.15a.714.714 0 01.714-.714h6.429a.714.714 0 01.714.714V5.22"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_1113_298350"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(3.148 3.078)","d":"M0 0h10v10H0z"}})])])])
          )
        }
      }
    